import React from 'react';
import { useTranslation } from 'react-i18next';
import SaasSection from '../saas/Section';
import SaasContainer from '../saas/Container';
import Reveal from '../saas/Reveal';
import { IdealAudienceGrid } from './IdealAudienceGrid';
import LandingCollageScene from './LandingCollageScene';
import LandingCollageCard from './LandingCollageCard';

const IdealForBusinessSection = () => {
  const { t } = useTranslation();
  const items = [t('idealFor.item1'), t('idealFor.item2'), t('idealFor.item3'), t('idealFor.item4')];

  return (
    <SaasSection variant="canvas" className="relative overflow-x-hidden">
      <div
        className="pointer-events-none absolute inset-0 bg-[linear-gradient(180deg,transparent_0%,rgba(245,243,246,0.5)_45%,transparent_100%)]"
        aria-hidden
      />
      <SaasContainer className="relative">
        <div className="grid grid-cols-1 items-center gap-10 md:grid-cols-2 md:gap-12 lg:gap-16">
          <Reveal className="order-2 md:order-2">
            <LandingCollageCard
              glow={
                <div
                  className="pointer-events-none absolute -end-24 -top-28 h-56 w-56 rounded-full bg-signal/12 blur-3xl"
                  aria-hidden
                />
              }
            >
              <LandingCollageScene variant="ideal" embedded />
            </LandingCollageCard>
          </Reveal>

          <div className="order-1 space-y-7 text-center md:order-1 md:space-y-8">
            <div className="mx-auto flex w-full max-w-2xl flex-col items-center text-center">
              <Reveal>
                <p className="type-eyebrow mb-3">{t('idealFor.eyebrow', { defaultValue: 'برای چه کسانی' })}</p>
                <span
                  className="mb-4 inline-block h-1.5 w-14 rounded-full bg-gradient-to-r from-emerald-status/90 via-signal/70 to-signal/60 md:mb-5"
                  aria-hidden
                />
              </Reveal>
              <Reveal delayMs={40}>
                <h2 className="type-section-title text-balance text-2xl md:text-heading-lg">
                  {t('idealFor.title')}
                </h2>
              </Reveal>
            </div>
            <div className="mx-auto w-full max-w-xl md:max-w-2xl">
              <IdealAudienceGrid items={items} />
            </div>
          </div>
        </div>
      </SaasContainer>
    </SaasSection>
  );
};

export default IdealForBusinessSection;
